import { Box, Stack, Typography } from '@mui/material';
import { ReactNode, FC } from 'react';
import { baseCardStyling } from './styles';
import BoxCornerIcon from './BoxCornerIcon';

type DetailsBoxProps = {
  title: string;
  subtitle: string;
  number: number | string;
  color: string;
  icon: ReactNode;
  left?: boolean;
};

export const DetailsBox: FC<DetailsBoxProps> = ({
  title,
  subtitle,
  number,
  color,
  icon,
  left = true,
}) => {
  return (
    <Box
      sx={{
        ...baseCardStyling,

        backgroundColor: '#36383aff',

        flex: 1, // This makes it grow to fill available space
        minHeight: 0, // Important for proper flex shrinking in boxes
        textAlign: 'center',
        display: 'flex', // Enable flex centering
        alignItems: 'center', // Vertical center
        justifyContent: 'center', // Horizontal center
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <BoxCornerIcon icon={icon} left={left} />
      <Stack direction="column" className="w-full">
        <Typography
          sx={(theme) => ({
            color: 'white',
            fontSize: '2rem',
            fontWeight: 'bold',
            textTransform: 'uppercase',
          })}
        >
          {title}
        </Typography>
        <Typography
          sx={(theme) => ({
            color: color,
            fontSize: '2.4rem',
            fontWeight: 'bold',
          })}
        >
          {subtitle}
        </Typography>
        <Typography
          sx={(theme) => ({
            color: 'white',
            fontSize: '6rem',
            fontWeight: 'bold',
          })}
        >
          {number ? number : '-'}
        </Typography>
      </Stack>
    </Box>
  );
};
